import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, input, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { IProgressStatus, ProgressStatusEnum } from 'src/app/class/progress-status';
import { PreInvoicingStateEnums } from 'src/app/enum/pre-invoicing-state-enums';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { SubrentalCutoffService } from 'src/app/services/subrental/subrental-cutoff.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-liquidation',
  templateUrl: './liquidation.component.html',
  styleUrls: ['./liquidation.component.scss'],
  standalone: false
})
export class LiquidationComponent implements OnInit {

  maxPosition = input<number>(0);
  permissionUpdatable = input<boolean>(true);

  animationLoad: boolean = false;
  branchName: string = "";
  disabledStart: boolean = false;
  errorLiquidation: number = 0;
  liquidationAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>();
  listObservers: Array<Subscription> = new Array<Subscription>();
  loadLiquidationModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  percentage: number = 0;
  showLiquidationProgress: boolean = false;
  showProgress!: boolean;
  showDownloadError!: boolean;
  subrentalCutoffCode: string = "";
  subrentalCutoffDate: string = "";
  subrentalCutoffId: number = 0;
  suscription: Subscription;
  visiblePdf: boolean = false;

  constructor(public config: DynamicDialogConfig,
    private subrentalCutoffService: SubrentalCutoffService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef,) { }

  ngOnInit(): void {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.subrentalCutoffId = inputs.subrentalCutoffId;
      this.branchName = inputs.branchName;
      this.subrentalCutoffCode = inputs.subrentalCutoffCode;
      this.subrentalCutoffDate = inputs.subrentalCutoffDate;
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
  }

  close() {
    this.percentage = 0;
    this.liquidationAlerts = new Array<PreInvoicingAlertModel>();
    this.visiblePdf = false;
    const data: ModalObjectType = {};
    if (this.disabledStart) {
      data.params = { reload: true };
      this.disabledStart = false;
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  async downloadErrorsTxt() {
    if (!this.liquidationAlerts || this.liquidationAlerts.length === 0) {
      return;
    }

    this.subrentalCutoffService.exportLiquidationErrorsTxt(this.liquidationAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresLiquidacionSubalquiler_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo.');
      }
    });
  }

  public downloadStatus(event: IProgressStatus) {
    switch (event.status) {
      case ProgressStatusEnum.START:
        this.showDownloadError = false;
        this.animationLoad = true;
        break;
      case ProgressStatusEnum.IN_PROGRESS:
        this.showProgress = true;
        this.percentage = event.percentage as number;
        break;
      case ProgressStatusEnum.COMPLETE:
        this.showProgress = false;
        this.animationLoad = false;
        break;
      case ProgressStatusEnum.ERROR:
        this.showProgress = false;
        this.showDownloadError = true;
        this.animationLoad = false;

        break;
    }
  }

  async liquidated() {
    this.disabledStart = true;
    this.showLiquidationProgress = true;
    this.downloadStatus({ status: ProgressStatusEnum.START });
    const load = this.subrentalCutoffService.liquidationBySubrentalCutoffId(this.subrentalCutoffId).subscribe(data => {
      switch (data.type) {
        case HttpEventType.DownloadProgress:
          this.downloadStatus({ status: ProgressStatusEnum.IN_PROGRESS, percentage: Math.round((data.loaded / data.total!) * 100) });
          break;
        case HttpEventType.Response:
          this.downloadStatus({ status: ProgressStatusEnum.COMPLETE });
          this.listObservers.push(load);
          if (data.body != null) {
            this.loadLiquidationModel = data.body
            //Obtengo la lista de alerta retornada de la liquidación
            this.liquidationAlerts = this.loadLiquidationModel?.alerts
            //Validacion para mostrar los mensajes de alerta y opción de exportarlos
            if (this.loadLiquidationModel.preInvoicingStateId == PreInvoicingStateEnums.error) {
              this.visiblePdf = true;
              this.toastHandlerService.showToast(
                'error',
                'El proceso ha terminado con Errores, expórtelos a PDF si lo desea.'
              );
            } else if (this.loadLiquidationModel?.preInvoicingStateId == PreInvoicingStateEnums.alerta) {
              this.visiblePdf = true;
              this.toastHandlerService.showToast(
                'error',
                'El proceso ha terminado con Alertas, expórtelos a PDF si lo desea.'
              );
            } else {
              this.visiblePdf = false;
              this.toastHandlerService.showToast(
                'success',
                'El proceso ha terminado exitosamente.'
              );
            }
            this.errorLiquidation = this.loadLiquidationModel?.preInvoicingStateId;
            this.showLiquidationProgress = false;
          }
          break;
      }
    },
      error => {
        this.downloadStatus({ status: ProgressStatusEnum.ERROR });
        this.showLiquidationProgress = false;
        console.error('Error al liquidar.', error);
      }
    );
  }

}
